module.exports = __webpack_public_path__ + "img/1F1E7-1F1F6.5e459616.svg";